import { forwardRef, type Ref, type ReactNode, type HTMLAttributes } from 'react';

export interface AppShellFooterProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  withBorder?: boolean;
}

export const AppShellFooter = forwardRef(function AppShellFooter(
  { children, withBorder = true, className, ...rest }: AppShellFooterProps,
  ref: Ref<HTMLElement>
): ReactNode {
  return (
    <footer
      ref={ref}
      className={[
        'rr-app-shell__footer',
        withBorder && 'rr-app-shell__footer--bordered',
        className
      ].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </footer>
  );
});
AppShellFooter.displayName = 'AppShellFooter';
